export type FaixaEtariaId = '6_8m' | '9_12m' | '1ano_mais' | 'todas';

export interface FaixaEtariaInfo {
    id: FaixaEtariaId;
    label: string;
    shortLabel: string;
    sublabel: string;
    emoji: string;
    badgeBg: string;
    badgeText: string;
    badgeBorder: string;
}

export const FAIXAS_ETARIAS: FaixaEtariaInfo[] = [
    {
        id: '6_8m',
        label: '6 a 8 meses (Fase 1)',
        shortLabel: '6 a 8 meses',
        sublabel: 'Introdução Alimentar',
        emoji: '👶',
        badgeBg: 'bg-emerald-50 dark:bg-emerald-950/50',
        badgeText: 'text-emerald-700 dark:text-emerald-300',
        badgeBorder: 'border-emerald-200 dark:border-emerald-800'
    },
    {
        id: '9_12m',
        label: '9 a 12 meses (Fase 2)',
        shortLabel: '9 a 12 meses',
        sublabel: 'Textura Granulada / Pequenos Pedaços',
        emoji: '🥣',
        badgeBg: 'bg-amber-50 dark:bg-amber-950/50',
        badgeText: 'text-amber-700 dark:text-amber-300',
        badgeBorder: 'border-amber-200 dark:border-amber-800'
    },
    {
        id: '1ano_mais',
        label: '+1 ano (Fase 3)',
        shortLabel: '+1 ano',
        sublabel: 'Refeição Infantil / Mastigação Ativa',
        emoji: '🧒',
        badgeBg: 'bg-indigo-50 dark:bg-indigo-950/50',
        badgeText: 'text-indigo-700 dark:text-indigo-300',
        badgeBorder: 'border-indigo-200 dark:border-indigo-800'
    },
    {
        id: 'todas',
        label: 'Livre / Todas as Idades',
        shortLabel: 'Todas as idades',
        sublabel: 'Para toda a família',
        emoji: '🌟',
        badgeBg: 'bg-slate-100 dark:bg-slate-800',
        badgeText: 'text-slate-700 dark:text-slate-300',
        badgeBorder: 'border-slate-200 dark:border-slate-700'
    }
];

export type TagNutricionalId =
    | 'sem_sal'
    | 'aplv'
    | 'sem_gluten'
    | 'vegetariano'
    | 'sem_ovo'
    | 'sem_soja'
    | 'sem_acucar'
    | 'organico';

export interface TagNutricionalInfo {
    id: TagNutricionalId;
    label: string;
    shortLabel: string;
    description: string;
    emoji: string;
    badgeBg: string;
    badgeText: string;
    badgeBorder: string;
    pillColor: string;
}

export const TAGS_NUTRICIONAIS: TagNutricionalInfo[] = [
    {
        id: 'sem_sal',
        label: 'Sem Sal Adicionado',
        shortLabel: 'Sem Sal',
        description: 'Ideal para bebês em introdução alimentar',
        emoji: '🧂',
        badgeBg: 'bg-teal-50 dark:bg-teal-950/50',
        badgeText: 'text-teal-700 dark:text-teal-300',
        badgeBorder: 'border-teal-200 dark:border-teal-800',
        pillColor: 'hover:border-teal-400'
    },
    {
        id: 'aplv',
        label: 'APLV (Sem Leite & Derivados)',
        shortLabel: 'APLV (Sem Leite)',
        description: 'Seguro para alérgicos à proteína do leite de vaca',
        emoji: '🥛',
        badgeBg: 'bg-sky-50 dark:bg-sky-950/50',
        badgeText: 'text-sky-700 dark:text-sky-300',
        badgeBorder: 'border-sky-200 dark:border-sky-800',
        pillColor: 'hover:border-sky-400'
    },
    {
        id: 'sem_gluten',
        label: 'Sem Glúten',
        shortLabel: 'Sem Glúten',
        description: 'Livre de trigo, centeio, cevada e aveia com glúten',
        emoji: '🌾',
        badgeBg: 'bg-amber-50 dark:bg-amber-950/50',
        badgeText: 'text-amber-700 dark:text-amber-300',
        badgeBorder: 'border-amber-200 dark:border-amber-800',
        pillColor: 'hover:border-amber-400'
    },
    {
        id: 'vegetariano',
        label: 'Vegetariano',
        shortLabel: 'Vegetariano',
        description: 'Sem carnes ou derivados de origem animal',
        emoji: '🥦',
        badgeBg: 'bg-emerald-50 dark:bg-emerald-950/50',
        badgeText: 'text-emerald-700 dark:text-emerald-300',
        badgeBorder: 'border-emerald-200 dark:border-emerald-800',
        pillColor: 'hover:border-emerald-400'
    },
    {
        id: 'sem_ovo',
        label: 'Sem Ovo',
        shortLabel: 'Sem Ovo',
        description: 'Seguro para alérgicos a ovo',
        emoji: '🥚',
        badgeBg: 'bg-orange-50 dark:bg-orange-950/50',
        badgeText: 'text-orange-700 dark:text-orange-300',
        badgeBorder: 'border-orange-200 dark:border-orange-800',
        pillColor: 'hover:border-orange-400'
    },
    {
        id: 'sem_soja',
        label: 'Sem Soja',
        shortLabel: 'Sem Soja',
        description: 'Livre de grãos ou derivados de soja',
        emoji: '🫘',
        badgeBg: 'bg-purple-50 dark:bg-purple-950/50',
        badgeText: 'text-purple-700 dark:text-purple-300',
        badgeBorder: 'border-purple-200 dark:border-purple-800',
        pillColor: 'hover:border-purple-400'
    },
    {
        id: 'sem_acucar',
        label: 'Sem Açúcar Adicionado',
        shortLabel: 'Sem Açúcar',
        description: 'Adoçado apenas com o sabor natural dos alimentos',
        emoji: '🍎',
        badgeBg: 'bg-rose-50 dark:bg-rose-950/50',
        badgeText: 'text-rose-700 dark:text-rose-300',
        badgeBorder: 'border-rose-200 dark:border-rose-800',
        pillColor: 'hover:border-rose-400'
    },
    {
        id: 'organico',
        label: '100% Orgânico',
        shortLabel: 'Orgânico',
        description: 'Ingredientes cultivados sem agrotóxicos',
        emoji: '🌿',
        badgeBg: 'bg-lime-50 dark:bg-lime-950/50',
        badgeText: 'text-lime-700 dark:text-lime-300',
        badgeBorder: 'border-lime-200 dark:border-lime-800',
        pillColor: 'hover:border-lime-400'
    }
];

export function getFaixaEtariaInfo(id?: string): FaixaEtariaInfo | undefined {
    if (!id) return undefined;
    return FAIXAS_ETARIAS.find(f => f.id === id);
}

export function getTagNutricionalInfo(id: string): TagNutricionalInfo | undefined {
    return TAGS_NUTRICIONAIS.find(t => t.id === id);
}
